import { authAPI } from './apiService'
import { Page } from './models'

export type GetPagesListResponse = {
  pages: Page[];
}

export type GetPageByUrlResponse = {
  page: Page;
}

const URL = '/pages'

const pagesService = {
  list: () => authAPI
    .get<GetPagesListResponse>(URL)
    .then((response) => response.data),

  getById: (id: number) => authAPI
    .get<GetPageByUrlResponse>(`${URL}/by-id/${id}`)
    .then((response) => response.data),

  create: (title: string, url: string, content: string) => authAPI
    .post(`${URL}/create`, { title, url, content })
    .then((response) => response.data),

  update: (id: number, title: string, url: string, content: string) => authAPI
    .post(`${URL}/update`, { id, title, url, content })
    .then((response) => response.data),

  getPublic: (url: string) => authAPI
    .get<GetPageByUrlResponse>(`${URL}/${url}`)
    .then((response) => response.data)
}

export default pagesService
